import { Button } from "@/components/ui/button";
import { PlusIcon } from "lucide-react";
import { ToolbarProps } from "react-big-calendar";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { ChannelCalendarItemAddForm } from "./ChannelCalendarItemAddForm";
import { CalendarCustomToolbar } from "@/components/calendar/CalendarCustomToolbar";

export const ChannelCalendarCustomToolbar = (toolbar: ToolbarProps) => {
  const { t } = useTranslation();
  const [showNewEventForm, setShowNewEventForm] = useState(false);

  return (
    <>
      <CalendarCustomToolbar
        toolbar={toolbar}
        extraRightButtons={
          <>
            <Button variant="outline" size="sm" onClick={() => setShowNewEventForm(true)}>
              <PlusIcon className="h-4 w-4" />
              {t("channel.newEvent")}
            </Button>
          </>
        }
      />
      {showNewEventForm && <ChannelCalendarItemAddForm onOpenChange={setShowNewEventForm} />}
    </>
  );
};
